import { useLiveQuery } from 'dexie-react-hooks';

import {
  getUnsyncedOutboxCount,
  type OutboxIdentity,
} from '../application/get-unsynced-outbox-count.js';
import { offlineDb } from '../infrastructure/dexie/offline-db.js';

/**
 * usePendingSyncCount (task 6.8) — live count of outbox items still needing
 * sync or operator attention, SCOPED to `identity` (coordinator finding #4
 * — a shared device must never show another operator's or another org's
 * count). `identity === null` (not yet resolved, or genuinely unauthenticated)
 * always reads 0 rather than querying unscoped. `?? 0` covers the brief
 * instant before `useLiveQuery`'s first read resolves. Pass
 * `{ includeRejected: false }` for the sync indicator (items still to sync).
 */
export function usePendingSyncCount(
  identity: OutboxIdentity | null,
  options: { includeRejected?: boolean } = {},
): number {
  const includeRejected = options.includeRejected ?? true;
  return (
    useLiveQuery(
      () =>
        identity
          ? getUnsyncedOutboxCount(offlineDb, identity, { includeRejected })
          : Promise.resolve(0),
      [identity?.orgId, identity?.capturedByUserId, includeRejected],
    ) ?? 0
  );
}
